// 获取跳转过来的url字段对象
export const getRequest = (obj) => {
  var urlSuffix = window.location.search // 获取url中"?"符后的字串
  var theRequest = new Object()
  if (urlSuffix.indexOf('?') !== -1) {
    // 如果后缀带有"?"
    var strArr = urlSuffix.substr(1).split('&') // 去掉"?"用"&"分割
    strArr.forEach((item) => {
      theRequest[item.split('=')[0]] = decodeURI(item.split('=')[1])
    })
  }
  Object.keys(obj).forEach((i) => {
    obj[i] = theRequest[i] || obj[i]
  })
  // console.log('obj', obj)
}
// 修改更新地址栏
const changeURLParam = (url, name, value) => {
  if (typeof value === 'string') {
    value = value.toString().replace(/(^\s*)|(\s*$)/, '') // 移除首尾空格
  }
  let url2
  if (!value) {
    // remove
    let reg = eval('/(([\?|&])' + name + '=[^&]*)(&)?/i')
    let res = url.match(reg)
    if (res) {
      if (res[2] && res[2] === '?') {
        // before has ?
        if (res[3]) {
          // after has &
          url2 = url.replace(reg, '?')
        } else {
          url2 = url.replace(reg, '')
        }
      } else {
        url2 = url.replace(reg, '$3')
      }
    }
  } else {
    let reg = eval('/([\?|&]' + name + '=)[^&]*/i')
    if (url.match(reg)) {
      // edit
      url2 = url.replace(reg, '$1' + value)
    } else {
      // add
      let reg = /([?](\w+=?)?)[^&]*/i
      let res = url.match(reg)
      url2 = url
      if (res) {
        if (res[0] !== '?') {
          url2 += '&'
        }
      } else {
        url2 += '?'
      }
      url2 += name + '=' + value
    }
  }
  return url2
}
export const changeURLStatic = (name, value) => {
  // 截取?和后面的内容，避免替换掉根地址
  var len = location.search
  let url = changeURLParam(len, name, value) // 修改 URL 参数
  history.replaceState(null, null, url) // 替换地址栏
}

// 关键词高亮
export const highLight = (title, keywords) => {
  // 如果标题中包含，关键字就替换一下
  if (title.includes(keywords)) {
    title = title.replace(
      keywords,
      // 这里是替换成html格式的数据，最好再加一个样式权重，保险一点
      '<em>' + keywords + '</em>'
    )
    return title
  }
  // 不包含的话还用这个
  else {
    return title
  }
}
// 输入字符转换
export const inputWordsReplaceFn = (text, num) => {
  if (
    text === 'null' ||
    text === 'undefined' ||
    text === '' ||
    typeof text !== 'string'
  ) {
    // // 去掉html代码
    // text = text.replace(/<[^>]+>/g, '')
    // //去掉双引号
    // text = text.replace(/\"/g, '')
    // //去掉单引号
    // text = text.replace(/\'/g, '')
    // //去掉尖括号
    // text = text.replace(/</g, '&lt;')
    // text = text.replace(/>/g, 'gt;')
    // // 去掉回车
    // text = text.replace(/\n/g, '')
    return
  } else {
    // 去掉html代码
    text = text.replace(/<[^>]+>/g, '')
    //去掉双引号
    text = text.replace(/\"/g, '')
    //去掉单引号
    text = text.replace(/\'/g, '')
    //去掉尖括号
    text = text.replace(/</g, '&lt;')
    text = text.replace(/>/g, 'gt;')
    // 去掉回车
    text = text.replace(/\n/g, '')
    // 去掉空格
    text = text.replace(/\s/g, '')
    return text
  }
}
// 数组深拷贝
export const arrDeepCopy = (oldArr) => {
  return JSON.parse(JSON.stringify(oldArr))
}
// 消除数组重复的数据
export const uniqueArr = (arr) => {
  if (arr.length <= 1) {
    return arr
  }
  var resultArr = []
  for (var i = 0; i < arr.length; i++) {
    for (var j = 0; j < resultArr.length; j++) {
      if (resultArr[j] == arr[i]) {
        break
      }
    }
    if (j == resultArr.length) {
      resultArr[resultArr.length] = arr[i]
    }
  }
  return resultArr
}
// 判断空值转换为boolean
export const toBoolean = (val) => {
  if (val === null || val === undefined || val === '' || val.length === 0) {
    return false
  } else {
    return true
  }
}
// 页面滚动到顶部
export const scrollToTop = () => {
  window.scrollTo(0, 0)
}